import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useViewerRole from "@/lib/rights/use-viewer-role";
import { useCarriersQuery } from "@babackapp/private-api-client/client/use-carriers-query";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@babackapp/ui/components/alert";
import { Button } from "@babackapp/ui/components/button";
import { PlugZap } from "lucide-react";
import { Link } from "react-router-dom";

// BBS-481: a carrier login that expired (UPS, 60 days) fails every label
// created through that line, and nothing else tells the merchant.
export default function CarrierAuthBanner() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const viewerRole = useViewerRole();
  // Reconnecting a carrier is a carrier-settings action, which other roles lack.
  const isOwnerOrAdmin = viewerRole === "owner" || viewerRole === "admin";
  const { data: carriers } = useCarriersQuery(shop.id, {
    enabled: isOwnerOrAdmin,
  });

  // Only a login that already stopped is urgent: "expiring" stays a badge.
  const hasExpired = carriers?.some((c) => c.authStatus?.state === "expired");
  if (!isOwnerOrAdmin || !hasExpired) return null;

  return (
    <Alert variant="warning" className="col-span-4">
      <PlugZap className="size-4" />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <AlertTitle>{t("home.carrierAuthBanner.heading")}</AlertTitle>
          <AlertDescription>
            {t("home.carrierAuthBanner.message")}
          </AlertDescription>
        </div>
        <Button asChild size="sm" className="w-fit shrink-0">
          <Link to={`/shops/${shop.id}/settings/carriers`}>
            {t("home.carrierAuthBanner.button")}
          </Link>
        </Button>
      </div>
    </Alert>
  );
}
